var perfEntries = performance.getEntriesByType("navigation"),
  hasLoadEventEnd = function () {
    return perfEntries && perfEntries[0].loadEventEnd > 0;
  },
  processEvents = function (e, t) {
    ["mouseover", "keydown", "touchmove", "touchstart", "wheel"].forEach(
      function (o) {
        e(o, eventCallback, t);
      }
    );
  };
function eventCallback() {
  prtgSpeedX.terminate(),
    //observer.disconnect(),
    ev(),
    processEvents(window.removeEventListener),
    n();
}
function seq(e, t, o) {
  (void 0 === o || void 0 === e[o]) && (o = 0),
    e[o](function () {
      ++o === e.length ? t() : seq(e, t, o);
    });
}
function initAndDispatchEvents() {
  if (hasLoadEventEnd()) {
    console.log("u=1"),
      ["DOMContentLoaded", "readystatechange", "load", "show"].forEach(
        function (e) {
          var t = document.createEvent("Event");
          t.initEvent(e, !0, !0),
            window.dispatchEvent(t),
            document.dispatchEvent(t);
        }
      );
    var e = window.document.createEvent("UIEvents");
    e.initUIEvent("resize", !0, !0, window, 0),
      window.dispatchEvent(e),
      document.dispatchEvent(e);
  }
}
function createScript(e, t) {
  var o = document.createElement("script");
  (o.type = "text/javascript"),
    e.src
      ? ((o.onload = t), (o.onerror = t), (o.src = e.src))
      : (o.textContent = e.innerText),
    (o.id = e.id),
    (o.async = !1),
    Object.assign(o.dataset, e.dataset),
    e.parentNode.removeChild(e),
    document.body.appendChild(o),
    e.src || t();
}
function n() {
  var e = document.querySelectorAll("script"),
    t = [];
  e.forEach(function (e) {
    "text/flspdscript" === e.getAttribute("type") &&
      t.push(function (t) {
        createScript(e, t);
      });
  }),
    t.length > 0 && seq(t, initAndDispatchEvents);
}
function ev() {
  var e = document.removeEventListeners;
  hasLoadEventEnd() &&
    void 0 !== e &&
    (console.log("ev=1"), ["DOMContentLoaded", "load"].forEach(e));
}
processEvents(window.addEventListener, { passive: !0 });
